// F6: turns whatever the user typed into a safe FTS5 MATCH expression.
// Raw input like `"`, `AND (`, `*` or `NEAR(` would otherwise be an FTS5 syntax error.

export const MAX_QUERY_LENGTH = 200;
export const MAX_TERMS = 10;
const MAX_TERM_LENGTH = 64;

/** Splits on anything that isn't a letter, digit or combining mark, matching FTS5's unicode61 tokenizer. */
export function searchTerms(input: unknown): string[] {
  if (typeof input !== "string") return [];
  const terms = input.slice(0, MAX_QUERY_LENGTH).toLowerCase().match(/[\p{L}\p{N}\p{M}]+/gu) ?? [];
  const unique: string[] = [];
  for (const t of terms) {
    const term = t.slice(0, MAX_TERM_LENGTH);
    if (!unique.includes(term)) unique.push(term);
    if (unique.length === MAX_TERMS) break;
  }
  return unique;
}

/** Every term must match; each is a quoted prefix query, so "acm" finds "Acme". Null when nothing is searchable. */
export function buildFtsQuery(input: unknown): string | null {
  const terms = searchTerms(input);
  if (terms.length === 0) return null;
  return terms.map((t) => `"${t.replace(/"/g, '""')}"*`).join(" ");
}

/** Offline fallback: same matching rules over locally cached contracts. */
export function matchesLocally(haystack: readonly (string | null | undefined)[], input: string): boolean {
  const terms = searchTerms(input);
  if (terms.length === 0) return true;
  const words = haystack
    .filter((h): h is string => typeof h === "string")
    .join(" ")
    .toLowerCase()
    .normalize("NFKD")
    .replace(/\p{M}/gu, "")
    .match(/[\p{L}\p{N}]+/gu) ?? [];
  return terms.every((t) => {
    const term = t.normalize("NFKD").replace(/\p{M}/gu, "");
    return words.some((w) => w.startsWith(term));
  });
}
